import { Box, Tooltip, Typography } from '@mui/material';
import PaymentCancelTooltipIcon from '@/assets/icons/PaymentCancelTooltipIcon';
import { getCancellationReasonLabel } from '@/constants/cancellationReasons';
import { BusinessProfileResponse } from '@/apis/business/types';

const tooltipSlotProps = {
  tooltip: {
    sx: {
      bgcolor: 'black',
      color: 'white',
      boxShadow: 3,
      fontSize: '0.85rem',
      borderRadius: 1,
      p: 1.25,
      lineHeight: 1.4,
      maxWidth: 320
    }
  },
  arrow: {
    sx: { color: 'black' }
  }
};

function buildInactiveTooltipContent(business: BusinessProfileResponse) {
  const reasonLabel = getCancellationReasonLabel(business.cancellation_reason);
  return (
    <Box component='ul' sx={{ m: 0, pl: 2, textAlign: 'left', '& li': { mb: 0.5, '&:last-of-type': { mb: 0 } } }}>
      <Box component='li'>{reasonLabel}</Box>
      {business.cancellation_feedback ? <Box component='li'>{business.cancellation_feedback}</Box> : null}
    </Box>
  );
}

type InactiveStatusTooltipProps = {
  business: BusinessProfileResponse;
  statusLabel: string;
  statusColor: string;
  statusBg: string;
};

export default function InactiveStatusTooltip({
  business,
  statusLabel,
  statusColor,
  statusBg
}: InactiveStatusTooltipProps) {
  return (
    <Box display='flex' alignItems='center' gap={1}>
      <Typography
        noWrap
        sx={{
          color: statusColor,
          bgcolor: statusBg,
          borderRadius: '100px',
          padding: { xs: '4px 8px', sm: '4px 13px' },
          width: 'fit-content',
          fontSize: { xs: '11px', sm: '12px' },
          fontWeight: 500
        }}
      >
        {statusLabel}
      </Typography>
      <Tooltip title={buildInactiveTooltipContent(business)} placement='top' arrow slotProps={tooltipSlotProps}>
        <Box component='span' display='inline-flex' sx={{ cursor: 'pointer', lineHeight: 0 }}>
          <PaymentCancelTooltipIcon />
        </Box>
      </Tooltip>
    </Box>
  );
}
